import React, { useContext, useEffect, useRef, useState } from 'react'
import ArrowIcon from '@mui/icons-material/ArrowForwardIos';
import axios from 'axios';
import { baseUrl, path } from '../../../constants';
import { Oval } from 'react-loader-spinner';
import CancelIcon from '@mui/icons-material/Cancel';
import Player from '../../../HulluWare/Player'
import { Link } from 'react-router-dom';
import { settingsContext } from '../../../Context/settingsProvider';

export default function Preview({ setSelectedCourse, selectedCourse }) {
  const {t} = useContext(settingsContext)
    // const [loaded, setLoaded] = useState(null)
    let s = selectedCourse
    const self = s.enrollments?.length
    const [source, setSource] = useState({
      url: baseUrl + s.preview,
      label: s.type,
      type: 'application/x-mpegURL',
      previewThumbnail: s.previewThumbnail,
      thumbnail: s.thumbnail,
      values: s.languages
})
    // const config = {
    //     onUploadProgress: progressEvent => console.log(progressEvent.loaded)
    // }

  return (
    <div className='fixed inset-0 bg-[#00000070] z-[9999999] flex items-center justify-center max-md:p-6'>
      <div className='relative'>

        <div className='flex items-center justify-center flex-col bg-black p-0 overflow-hidden rounded-md gap-5'>
            {/* {loaded == false &&
            <div className='flex flex-col gap-2 items-center'>
                <VideocamOffIcon style={{fontSize: 60, color: '#000000'}}>Filled</VideocamOffIcon>
                <p className='text-black font-bold text-[25px]'>No preview is found for this course.</p>
            </div>
             } */}
           
             <Player options={{source}} style={{}} /> 
             <Link to={(self ? '/learn/' : '/course/') + s.id} className='p-2 w-full  self-center rounded-md bg-main text-white no-underline text-md font-bold flex items-center justify-center gap-2'>
               {self ? t('START_LEARNING') : t('GET_COURSE')}
               <ArrowIcon style={{fontSize: 18}}>Filled</ArrowIcon>
              </Link>
        </div>
        <button onClick={() => setSelectedCourse(null)} className='absolute outline-none bg-white flex items-center justify-center rounded-full bg-none -top-3 -right-3'>
                <CancelIcon style={{fontSize: 25, color: '#000000'}}>Filled</CancelIcon>
             </button>
        </div>
    </div>
  )
}
